import React from 'react'
import PropTypes from 'prop-types'
import CSVError from './LmsCSVError.jsx'
import { DownloadIcon, SpinnerAnimatedIcon } from 'secondstep-components'
import {
  ReportsDropdownWrapper,
  StyledCsvDownloadMenu,
} from './ReportsDropdown.styles.js'
import { DOWNLOAD_LINK_TEXT } from './constants'

const ReportsDropdown = ({
  classesCount,
  error,
  historicalReports,
  historicalReportingOnClick,
  isFetching,
  lessonReportingOnClick,
  onClickCurrentYear,
  schoolCsvDownloadTooltip,
  excludeLabels = false,
  buttonText = DOWNLOAD_LINK_TEXT,
}) => {
  if (error) {
    return <CSVError />
  }

  const shouldShowCsvMenu = !!(classesCount > 0 || historicalReports) && !error

  if (!shouldShowCsvMenu) {
    return null
  }

  return (
    <ReportsDropdownWrapper>
      <StyledCsvDownloadMenu
        buttonIcon={isFetching ? SpinnerAnimatedIcon : DownloadIcon}
        buttonText={buttonText}
        dataTestId="select-csv"
        disabledSelectButton={isFetching}
        hasScrollableHistoricalReports={true}
        historicalReports={historicalReports}
        name="csv-download"
        onClickCurrent={lessonReportingOnClick}
        onClickCurrentYear={onClickCurrentYear}
        onClickHistorical={historicalReportingOnClick}
        showDownloadIcons={false}
        showLoadingText={false}
      />
    </ReportsDropdownWrapper>
  )
}

ReportsDropdown.propTypes = {
  buttonText: PropTypes.string,
  classesCount: PropTypes.number,
  error: PropTypes.object,
  excludeLabels: PropTypes.bool,
  historicalReportingOnClick: PropTypes.func,
  historicalReports: PropTypes.array,
  isFetching: PropTypes.bool,
  isFetchingDocumentUrl: PropTypes.bool,
  isFetchingHistoricalReportData: PropTypes.bool,
  lessonReportingOnClick: PropTypes.func,
  onClickCurrentYear: PropTypes.func,
  schoolCsvDownloadTooltip: PropTypes.string,
}

export default ReportsDropdown
